module.exports = __webpack_public_path__ + "img/github.e129f5eb.svg";